export const isValidZipCode = (zipCode: string): boolean => {
  const regex = /^[0-9]{5}(?:-[0-9]{4})?$/;
  return regex.test(zipCode);
};

export const isNonEmptyString = (text: string): boolean => Boolean(text) && !/^\W+$/.test(text);

export const isJSONParsable = (text: string): boolean => {
  try {
    JSON.parse(text);
    return true;
  } catch (e) {
    return false;
  }
};
